export default "__VITE_ASSET___0k6Itsq__"